
class ShapeRadialSeriesArgs {
    // Radials from center point to edges
    // The idea here is to expand a circle, but do so with shrinking 
    // outer layers. 
    //
    // shape - The shape to create the radials for. 
    // 
    // arc       - The arc of the outer part of the radial, 0-1.
    //              along the provided shape (so sweep).  
    //              should probably be something on the smaller side unless
    //              you want very large pie slices.  
    // step       - How much to move along the outer shape before
    //              drawing next arc. Defaults to the same value as arc.
    // radius     - How far the radials should go to the outside, 
    //              defaults to 1 (all the way).  
    // centerPt     - Object (with x, y members).
    //              allows picking a custom center point  
    // maxRadials - how many radials to add. defaults to roughly 1 full
    //              rotation of the object
    //              
    //// Randomization or grow/shrink factors
    // arcRange  - randomness range for the sizing.
    // stepRange  - randomness range to adjust how large the step is. 
    // radiusRange  - randomness range to adjust how large the radius is. 
    // arcChange    - Optional value to shrink the coverage of the 
    //                radials. positive grows, negative shrinks.
    //                Defaults to none (0). 
    // arcChangeRepeat - Array, numbers to do a repetetive shrink/grow 
    //                   width of the radials to build patterns with.
    // radiusChangeRepeat - Array (number) - array that will be repeated 
    //                   to grow/shrink the radius of radials.
	//
    constructor(
        arc, 
        step,
        radius
    ) {
        this.arc = arc
        this.step = step
        this.radius = radius
        this.centerPt = {}
        this.isCentered = false
        this.connectPoints = false
        this.maxRadials = Math.floor(1 / arc)
        this.arcRange = [1, 1]
        this.stepRange = [1, 1]
        this.radiusRange = [1, 1]
        this.arcChangeRepeat = [1, 1]
        this.radiusChangeRepeat = [1, 1]
        this.arcChange = 0
        this.stepChange = 0
        this.radiusChange = 0
    }

    setCenterPt(centerPt) {
        this.centerPt = centerPt
        return this
    }

    setIsCentered(isCentered) {
        this.isCentered = isCentered
        return this
    }

    setConnectPoints(connect) {
        this.connectPoints = connect
        return this
    }

    setMaxRadials(max) {
        this.maxRadials = max
        return this
    }

    // Take an array of two ints, will use those to randomize arc size
    setArcRange(arcRange) {
        this.arcRange = arcRange
        return this
    }

    // Take an array of two ints, will use those to randomize step
    setStepRange(stepRange) {
        this.stepRange = stepRange
        return this
    }

    // Take an array of two ints, will use those to randomize radius
    setRadiusRange(radiusRange) {
        this.radiusRange = radiusRange
        return this
    }

    // Take an array of two or more float, 
    // will add them into arc calculations in repeating fashion
    setArcChangeRepeat(arcChangeRepeat) {
        this.arcChangeRepeat = arcChangeRepeat
        return this
    }

    // Take an array of two or more float, 
    // will add them into radius calculations in repeating fashion
    setRadiusChangeRepeat(radiusChangeRepeat) {
        this.radiusChangeRepeat = radiusChangeRepeat
        return this
    }

    // attenuation factor for arc size, compounds across draws
    setArcChange(arcChange) {
        this.arcChange = arcChange
        return this
    }

    // Take an array of two ints, will use those to randomize step
    setStepChange(stepChange) {
        this.stepChange = stepChange
        return this
    }

    // Take an array of two ints, will use those to randomize size
    setRadiusChange(radiusChange) {
        this.radiusChange = radiusChange
        return this
    }
}

export { ShapeRadialSeriesArgs }
